import { Box, Grid, Button } from "@mui/material";
import { colors } from "../../ui/colors";
import { CalendarMode } from "../types";
import { useCalendarDateSelectorState, useSetCalendarDateSelector } from "../states/useCalendarDateSelector";

interface CalendarModeSelectorProps {
  modes: Record<CalendarMode, string>;
}

export function CalendarModeSelector({ modes }: CalendarModeSelectorProps) {
  const { mainMode } = useCalendarDateSelectorState();
  const { setPayload } = useSetCalendarDateSelector();

  const handleModeChange = (mode: CalendarMode) => {
    setPayload({ mainMode: mode, range: { start: null, end: null }, showCard: false });
  };

  return (
    <Box sx={{ bgcolor: "var(--fx-surface-base, #FFFFFF)", borderRadius: "12px", p: 0.7, width: "100%" }}>
      <Grid container spacing={0.5} wrap="nowrap">
        {Object.keys(modes).map((m) => {
          const isSelected = mainMode === m;
          return (
            <Grid item xs key={m}>
              <Button
                fullWidth
                size="small"
                onClick={() => handleModeChange(m as CalendarMode)}
                sx={{
                  borderRadius: 1.5,
                  textTransform: "none",
                  fontWeight: 800,
                  fontSize: { xs: 11, sm: 12, md: 13 },
                  py: 1,
                  px: 0.5,
                  minWidth: 0,
                  bgcolor: isSelected ? colors.orange.base : "transparent",
                  color: isSelected ? "white" : "#94a3b8",
                  boxShadow: "none",
                  "&:hover": { bgcolor: isSelected ? colors.orange.base : "rgba(255, 107, 0, 0.08)" },
                }}
              >
                {modes[m as CalendarMode]}
              </Button>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
